import {
  createWebhookIntegrationAsync,
  createWebhookPayloadAsync,
  deleteWebhookIntegrationAsync,
  deleteWebhookPayloadByIdAsync,
  getAllWebhookIntegrationByLicense,
  getAllWebhookPayloadsByLicenseAsync,
  getWebhookIntegrationByIdAsync,
  getWebhookPayloadByIdAsync,
  updateWebhookIntegrationAsync,
  updateWebhookPayloadByIdAsync,
} from '../../index';
import { useMutation } from 'react-query';

export const useCreateWebhookIntegrationAsync = () =>
  useMutation(createWebhookIntegrationAsync);

export const useGetWebhookIntegrationByIdAsync = () =>
  useMutation(getWebhookIntegrationByIdAsync);

export const useGetAllWebhookPayloadsByLicenseAsync = () =>
  useMutation(getAllWebhookPayloadsByLicenseAsync);

export const useGetAllWebhookIntegrationByLicenseAsync = () =>
  useMutation(getAllWebhookIntegrationByLicense);

export const useUpdateWebhookIntegrationAsync = () =>
  useMutation(updateWebhookIntegrationAsync);

export const useDeleteWebhookIntegrationAsync = () =>
  useMutation(deleteWebhookIntegrationAsync);

export const useCreateWebhookPayloadAsync = () =>
  useMutation(createWebhookPayloadAsync);

export const useGetWebhookPayloadByIdAsync = () =>
  useMutation(getWebhookPayloadByIdAsync);

export const useDeleteWebhookPayloadByIdAsync = () =>
  useMutation(deleteWebhookPayloadByIdAsync);

export const useUpdateWebhookPayloadByIdAsync = () =>
  useMutation(updateWebhookPayloadByIdAsync);
